module.exports = __webpack_public_path__ + "img/member_new_02.13580467.png";